import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import styles from './PopOver.module.scss';

PopOver.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func.isRequired,
};

PopOver.defaultProps = {
  className: '',
  isOpen: false,
};

export default function PopOver(props) {
  const {
    children,
    className,
    isOpen,
    setIsOpen,
  } = props;
  const popOverRef = useRef(null);

  const handleDocumentClick = (e) => {
    if (popOverRef.current && popOverRef.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setIsOpen(false);
  };

  useEffect(() => {
    // add when mounted
    document.addEventListener('mousedown', handleDocumentClick);
    return () => {
      document.removeEventListener('mousedown', handleDocumentClick);
    };
  }, []);

  return (
    <div
      className={ `
        ${styles.PopOver}
        ${isOpen ? styles.isOpen : ''}
        ${className}
      ` }
      ref={ popOverRef }
    >
      {children}
    </div>
  );
}
